import React from 'react';
import { Marker, Polyline } from 'google-maps-react';
import { Marker as NewMarker } from '@react-google-maps/api';

export const locationHandler = ({
  blockedPermissionsMessage,
  permissionGrantedCallback,
  permissionDeniedCallback,
}) => {
  if (navigator.permissions && navigator.permissions.query)
    navigator.permissions
      .query({ name: 'geolocation' })
      .then(function (result) {
        if (result.state === 'granted') {
          (permissionGrantedCallback || (() => {}))(result);
        } else if (result.state === 'prompt') {
          navigator.geolocation.getCurrentPosition(
            permissionGrantedCallback || (() => {}),
            () => {
              permissionDeniedCallback();
              alert(
                `You will have to grant location permissions in order to ${blockedPermissionsMessage}`
              );
            },
            {}
          );
        } else if (result.state === 'denied') {
          alert(
            `You will have to grant location permissions in order to ${blockedPermissionsMessage}`
          );
          (permissionDeniedCallback || (() => {}))(result);
        }
      });
  else if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      permissionGrantedCallback || (() => {}),
      () => {
        permissionDeniedCallback();
        alert(
          `You will have to grant location permissions in order to ${blockedPermissionsMessage}`
        );
      },
      {}
    );
  }
};

export const getCurrentLocation = (successCallback, failureCallback) => {
  navigator.geolocation.getCurrentPosition(
    successCallback || (() => {}),
    failureCallback || (() => {}),
    {}
  );
};

export const getCoords = (props) => {
  const [lat, lng] =
    props.coords || (props.location || '').split(',').map(parseFloat);

  return {
    lat,
    lng,
  };
};

export const getMapCenter = (marker1, marker2) => {
  return {
    lat: (marker1.lat + marker2.lat) / 2,
    lng: (marker1.lng + marker2.lng) / 2,
  };
};

export const getBounds = (markers, google) => {
  const newBounds = new google.maps.LatLngBounds();
  markers.forEach((marker) => {
    newBounds.extend(marker);
  });

  return newBounds;
};

export const getMarker = (props) => {
  const { lat, lng } = getCoords({
    ...(props.marker.location ? { location: props.marker.location } : {}),
    ...(props.marker.coords ? { coords: props.marker.coords } : {}),
  });

  return (
    <Marker
      title={props.marker.title}
      name={props.name}
      position={{ lat, lng }}
      draggable={props.draggable}
      onDragend={props.onDragend}
      icon={{
        url: require(`../assets/images/${props.icon}.svg`),
        anchor: new props.google.maps.Point(24, 48),
        scaledSize: new props.google.maps.Size(48, 48),
      }}
    />
  );
};
export const getNewMarker = (props) => {
  const { lat, lng } = getCoords({
    ...(props.marker.location ? { location: props.marker.location } : {}),
    ...(props.marker.coords ? { coords: props.marker.coords } : {}),
  });
  return (
    <NewMarker
      title={props.name}
      // name={props.name}
      position={{ lat, lng }}
      draggable={props.draggable}
      onDragEnd={props.onDragend}
      animation={props.animation}
      label={
        props.label && {
          text: props.label,
          color: '#ffffff',
          fontWeight: 'bold',
          fontSize: '12px',
          className: props.styleClass,
        }
      }
      icon={{
        url: require(`../assets/images/${props.icon}.svg`),
        anchor: new props.google.maps.Point(
          props.size / 2 || 24,
          props.anchor || 48
        ),
        scaledSize: new props.google.maps.Size(
          props.size || 48,
          props.size || 48
        ),
        labelOrigin: new props.google.maps.Point(24, 60),
      }}
    />
  );
};

export const getPolyline = (path, google, setPolyline) => {
  const mapDirector = new google.maps.DirectionsService();

  const origin = path.pickup;
  const destination = path.destination;

  const DirectionRequest = {
    travelMode: 'DRIVING',
    origin,
    destination,
  };

  mapDirector.route(DirectionRequest, (data) => {
    setPolyline(
      (((data.routes || [])[0] || {}).overview_path || []).map((coords) => ({
        lat: coords.lat(),
        lng: coords.lng(),
      }))
    );
  });
};
